import { useRequiredParams } from '@pba/react-router';
import { useUser } from 'features/auth';
import {
  CurrentMemberProfile,
  MemberLayout,
  MemberProfileHeader,
  OtherMemberProfile,
  ViewerLayout,
} from 'features/users';
import { useGetPathToEntityDetail } from 'pages/hooks';
import { useNavigateToMembersEntities } from '../hooks';

const PageMemberProfile = () => {
  const { memberId } = useRequiredParams<{ memberId: string }>();
  const { nodeUserData: nodeViewer, railsUserData: viewer } = useUser();
  const isViewer = memberId === viewer.id || memberId === nodeViewer._id;
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToMembersEntity = useNavigateToMembersEntities();

  if (isViewer) {
    return (
      <ViewerLayout header={(member) => <MemberProfileHeader member={member} />} viewer={viewer}>
        {(member) => <CurrentMemberProfile member={member} />}
      </ViewerLayout>
    );
  }

  return (
    <MemberLayout header={(member) => <MemberProfileHeader member={member} />} memberId={memberId}>
      {(member) => (
        <OtherMemberProfile
          getPathToEntityDetail={getPathToEntityDetail}
          member={member}
          navigateToMembersEntity={navigateToMembersEntity}
        />
      )}
    </MemberLayout>
  );
};

export default PageMemberProfile;
